import {
  createContext,
  type Dispatch,
  type ReactNode,
  type SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";
import { useIsNewEntry } from "src/hooks";
interface IPendingFilesContext {
  pendingFiles: File[];
  setPendingFiles: Dispatch<SetStateAction<File[]>>;
}

const PendingFilesContext = createContext<IPendingFilesContext | null>(null);

export const PendingFilesProvider = ({ children }: { children: ReactNode }) => {
  const [pendingFiles, setPendingFiles] = useState<File[]>([]);

  const isNewEntry = useIsNewEntry();

  useEffect(() => {
    setPendingFiles([]);
  }, [isNewEntry]);

  return (
    <PendingFilesContext.Provider value={{ pendingFiles, setPendingFiles }}>
      {children}
    </PendingFilesContext.Provider>
  );
};

export const usePendingFilesContext = () => {
  const context = useContext(PendingFilesContext);
  // if (!context) {
  //   // throw new Error(
  //   //   "usePendingFilesContext must be used within a PendingFilesProvider",
  //   // );
  // }
  return context;
};
